import { render, staticRenderFns } from "./AnswerBubble.vue?vue&type=template&id=0a38d7e2&lang=pug&"
import script from "./AnswerBubble.vue?vue&type=script&lang=ts&"
export * from "./AnswerBubble.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports